import React, { memo } from 'react';
import { Box, InputAdornment, Tooltip } from '@mui/material';
import { FastField } from 'formik';
import { LanguageCodeEnum } from '../common/enums/common.enum';
import GenericTextField from './GenericTextField/GenericTextField';
import { ReactComponent as WarningTriangleIcon } from '../assets/warning-triangle-icon.svg';

interface FastItemFieldProps {
  index: number;
  fieldName: string;
  lang: LanguageCodeEnum;
}

const FastItemField: React.FC<FastItemFieldProps> = memo(({ index, fieldName, lang }) => {
  const titleFieldName = `${fieldName}[${index}].title.${lang}`;

  return (
    <Box display="flex" alignItems="center" gap={1.5}>
      <FastField name={titleFieldName}>
        {({ field, meta }: any) => {
          const fieldValue = field.value;
          const highlightError = lang === LanguageCodeEnum.ENG && meta.touched && !!meta.error;
          const showWarning = lang !== LanguageCodeEnum.ENG && !fieldValue;

          return (
            <GenericTextField
              label=""
              size="small"
              {...field}
              error={highlightError}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: showWarning ? '#F1C40F' : undefined
                  },
                  '&:hover fieldset': {
                    borderColor: showWarning ? '#F1C40F' : undefined
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: showWarning ? '#F1C40F' : undefined
                  }
                }
              }}
              InputProps={{
                endAdornment: showWarning ? (
                  <InputAdornment position="end">
                    <Box sx={{ pr: 1, display: 'flex', alignItems: 'center' }}>
                      <Tooltip title="Cleared fields will be displayed in English for users"
                      >
                        <WarningTriangleIcon style={{ width: 24, height: 24, cursor: 'auto'  }} />
                      </Tooltip>
                    </Box>
                  </InputAdornment>
                ) : undefined
              }}
            />
          );
        }}
      </FastField>
    </Box>
  );
});

export default FastItemField;
